import { createReducer } from 'typesafe-actions'
import { Reducer } from 'redux'
import {
  AppointmentState,
  AppointmentsAction,
  AppointmentsTypes,
  AppointmentVariant
} from '../types'

export const initState: AppointmentState = {
  isFetching: false,
  selected: AppointmentVariant.Appointment,
  data: {
    content: []
  },
}

export const appointmentsReducer: Reducer<
  AppointmentState,
  AppointmentsAction
> = createReducer<AppointmentState, AppointmentsAction>(initState, {
  [AppointmentsTypes.FETCH_APPOINTMENTS_REQUEST]: (
    state: AppointmentState
  ) => ({
    ...state,
    isFetching: true,
    data: {
      ...state.data,
      content: []
    }
  }),
  [AppointmentsTypes.FETCH_APPOINTMENTS_SUCCESS]: (
    state: AppointmentState,
    action: AppointmentsAction
  ) => ({
    ...state,
    isFetching: false,
    // @ts-ignore
    data: action.payload.data
  }),
  [AppointmentsTypes.FETCH_APPOINTMENTS_FAIL]: (state: AppointmentState) => ({
    ...state,
    isFetching: false
  })
})

export default appointmentsReducer
